/* eslint-disable import/prefer-default-export */
import { computed } from 'vue';
import { useProductPrice } from '@modules/price/composables';
import { useProductData } from '@composables/useProductData';
import { useProduct } from '@modules/product';

/**
 * * Get the product price for the ATB
 */
export const useATBPriceBCOM = () => {
  const { productId } = useProduct();
  const product = useProductData(productId);

  const selectedPrice = useProductPrice();

  return computed(() => selectedPrice.value || product.value.pricing.price);
};
